import { render, staticRenderFns } from "./EconfConfiguracoes.vue?vue&type=template&id=a62320c4"
import script from "./EconfConfiguracoes.vue?vue&type=script&lang=js"
export * from "./EconfConfiguracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports